/* eslint-disable no-unused-vars */
/* These imports are only used by TS typechecker */
import LogoVersionRequest from "./LogoVersionRequest";
import Brand from "./Brand";
import LogoVersion from "./LogoVersion";
import Industry from "./Industry";
import BrandRequestBrand from "./BrandRequestBrand";
/* eslint-enable no-unused-vars */

export default class BrandRequest {
	id;
	name;
	contentWebsite;
	/** @type {Industry} */
	industry = new Industry();
	/** @type {LogoVersion[]} */
	logoVersions;
	isInLibrary;
	/** @type {number} */
	status;
	/** @type {Brand[]} */
	brands = [];
	/** @type {LogoVersionRequest[]} */
	logoVersionRequests = [];
	countryId;
	industryId;
	note;
	meta;
	exampleUrls;
	/** @type {Partial<BrandRequestBrand>[]} */
	brandRequestBrands = [];

	/**
	 * 
	 * @param {Partial<BrandRequest>=} initialState 
	 */
	constructor(initialState) {
		Object.assign(this, initialState);
	}
}



// WEBPACK FOOTER //
// ./src/models/BrandRequest.js